export default __webpack_public_path__ + "static/media/technichinformobespech.526c17c2.pdf";